<template>
    <video controls class="video-comp">
        <source :src="attach.data.videoUrl" />
        Sorry, your browser doesn't support embedded videos.
    </video>
</template>

<script>
export default {
    props: ['attach'],
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.video-comp {
    min-width: 380px;
    width: 80%;
}
</style>
